import { Space, Row, Col, Button, Modal } from 'antd'
import { setGraphCreatingEdge, setQueryResults } from '../../Context/actions'
import { useGraphData } from '../../Context'
import { NodePicker, RelationPicker } from 'Components'
import { getNamespaces, splitUid } from 'Services/WeaverUtils'
import { useEffect, useState } from 'react'
import Feather from '@sysunite/react-feather'

const CreateRelationModal = () => {
  const [{ creatingEdgeProps }, dispatch] = useGraphData()
  const [loading, setLoading] = useState(true)
  const [sources, setSources] = useState([])
  const [relKeys, setRelKeys] = useState([])
  const [targets, setTargets] = useState([])
  const [initialData, setInitialData] = useState([])

  useEffect(() => {
    (async () => {
      setLoading(true)
      let fromNodes = []
      let toNodes = []
      const { edgeData } = creatingEdgeProps
      if (edgeData) {
        if (edgeData.from && edgeData.to) {
          setSources([edgeData.from])
          setTargets([edgeData.to])
        } else if (edgeData.from && !edgeData.to) {
          if (typeof edgeData.from === 'string') {
            setSources([edgeData.from])
          } else {
            setSources(edgeData.from)
          }
        } else if (edgeData.to && !edgeData.from) {
          if (typeof edgeData.to === 'string') {
            setTargets([edgeData.to])
          } else {
            setTargets(edgeData.to)
          }
        }
        if (edgeData.from) {
          fromNodes = await new Weaver.Query().restrict(edgeData.from).find()
        }

        if (edgeData.to) {
          toNodes = await new Weaver.Query().restrict(edgeData.to).find()
        }

        setInitialData([
          ...fromNodes,
          ...toNodes,
        ])
      }
      setLoading(false)
    })()
  }, [creatingEdgeProps])

  const getRelationNamespaceKeys = (keys) =>
    keys.map((key) => {
      const namespace = _.findKey(getNamespaces(), (ns) => key.includes(ns))
      return namespace ? `${namespace}${key.split(':')[1]}` : key
    })

  const close = () => {
    dispatch(setGraphCreatingEdge(undefined))
    setSources([])
    setRelKeys([])
    setTargets([])
  }

  const onCreate = async () => {
    creatingEdgeProps.promise.resolve({
      sources,
      relKeys,
      targets
    })
    setSources([])
    setRelKeys([])
    setTargets([])
  }

  const Footer =
    <Button
      type='primary'
      onClick={onCreate}
      disabled={
        sources.length === 0 ||
        relKeys.length === 0 ||
        targets.length === 0
      }
    >
      Create
    </Button>

  if (loading) {
    return <div/>
  } else {
    return (
      <Modal
        title='Create relation'
        maskClosable={false}
        onCancel={close}
        destroyOnClose={true}
        visible={creatingEdgeProps}
        centered={true}
        mask={false}
        footer={Footer}
      >
        <Space style={{ width: '100%' }} direction='vertical'>
          <Row align="middle" gutter={8}>
            <Col>
              <Feather type="circle" style={{ color: '#333' }} />
            </Col>
            <Col flex={1}>
              <NodePicker
                initialData={initialData}
                defaultValue={sources}
                placeholder="Source nodes"
                mode="multiple"
                onSelect={setSources}
                style={{ width: '100%' }} />
            </Col>
          </Row>

          <Row align="middle" gutter={8}>
            <Col>
              <Feather
                type="arrow-down"
                style={{ color: '#333' }} />
            </Col>
            <Col flex={1}>
              <RelationPicker
                style={{ width: '100%' }}
                onChange={(keys) => {
                  const newKeys = getRelationNamespaceKeys(keys)
                  setRelKeys(newKeys)
                }}
              />
            </Col>
          </Row>

          <Row align="middle" gutter={8}>
            <Col>
              <Feather type="circle" style={{ color: '#333' }} />
            </Col>
            <Col flex={1}>
              <NodePicker
                initialData={initialData}
                defaultValue={targets}
                placeholder="Target nodes"
                mode="multiple"
                onSelect={setTargets}
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
        </Space>
      </Modal>
    )
  }
}

export default CreateRelationModal
